import React from 'react';
import PropTypes from 'prop-types';

import { Trans } from 'react-i18next';

import { Card, Checkbox, Icon } from 'semantic-ui-react';

export default class AttendeeCard extends React.Component {
    changeSearch(orderId) {
        return this.props.changeSearch(search => (search ? `${search} ${orderId}` : orderId));
    }

    renderAttendeeInfo() {
        let { attendee, rates } = this.props;
        let rate = rates.find(rate => +rate.id === +attendee.rate);

        return (
            <Card.Content>
                <div className="attendee-card-header">
                    <div className="attendee-cell left">
                        <Checkbox
                            checked={this.props.isChecked}
                            onChange={(event, data) =>
                                this.props.onSelected(
                                    {
                                        event,
                                        data
                                    },
                                    this.props.attendee,
                                    this.props.index
                                )
                            }
                        />
                        <span className="attendee-card-id-reference" onClick={() => this.props.onClick(attendee.pk)}>
                            #{attendee.id_weez_ticket}
                        </span>
                    </div>
                    <div className="attendee-cell right">
                        <Icon className="menu" color="grey" size="large" name="ellipsis horizontal" />
                    </div>
                </div>
                <Card.Header>
                    <div className="attendee-cell attendee-cell-secondary">
                        <div className="avatar-cell-name">
                            <div>{`${attendee.first_name} ${attendee.last_name}`}</div>
                        </div>
                        {rate ? (
                            <div>
                                <div>
                                    <Trans i18nKey="attendee.info.rate">Rate</Trans>
                                </div>
                                <div className="attendee-card-rate">{rate.resolved_name}</div>
                            </div>
                        ) : null}
                        <div>{attendee.paid_price}€</div>
                        <div style={{ fontWeight: '400', fontSize: '1rem' }}>{new Date(attendee.order.sold_date).toLocaleDateString()}</div>
                    </div>
                </Card.Header>
                <Card.Meta>
                    <span className="attendee-order-reference" onClick={() => this.changeSearch(attendee.order.transaction_reference)}>
                        <Trans i18nKey="attendee.orderId" values={{ orderId: attendee.order.transaction_reference || '-' }}>
                            Order #%orderId%
                        </Trans>
                    </span>
                </Card.Meta>
            </Card.Content>
        );
    }

    renderAttendeeStatuses() {
        let scanned = this.props.attendee.scanned;

        return (
            <React.Fragment>
                <div className="attendee-cell" style={{ textAlign: 'right' }}>
                    <Icon size="large" name="qrcode" color={scanned ? 'green' : 'grey'} />
                    <Trans i18nKey={'attendee' + (scanned ? '.scanned' : '.not_scanned')}>{scanned ? 'Scanned' : 'Not scanned'}</Trans>
                </div>
                {/* This is left commented on purpose for reference and future use */}
                {/*<div className="attendee-cell right">
                    <Icon size="big" name="check circle outline" color={paid ? 'green' : 'grey'}/>
                    <Trans i18nKey={'attendee' + (paid ? '.paid' : '.not_paid')}>
                        { paid ? 'Paid' : 'Not paid' }
                    </Trans>
                </div>*/}
            </React.Fragment>
        );
    }

    render() {
        return (
            <Card className={`attendee-card ${this.props.isChecked ? 'checked' : ''}`}>
                {this.renderAttendeeInfo()}
                <Card.Content extra>{this.renderAttendeeStatuses()}</Card.Content>
            </Card>
        );
    }
}

AttendeeCard.defaultProps = {
    isChecked: false,
    rates: []
};

AttendeeCard.propTypes = {
    attendee: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    isChecked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    onSelected: PropTypes.func.isRequired,
    changeSearch: PropTypes.func.isRequired,
    rates: PropTypes.array
};
